import React from 'react';
import Mixpanel from 'mixpanel-browser';
import mixpanelConfig from './MixpanelConfig';

Mixpanel.init(mixpanelConfig(process.env.REACT_APP_RENTLINE_APP_ENV));

export const MixpanelContext  = React.createContext(Mixpanel);